import React from 'react';
import PropTypes from 'prop-types';

import MartyLink from 'components/common/MartyLink';
import PaymentCard from 'components/account/PaymentCard';
import styles from 'styles/components/account/cardLayout.scss';

const PaymentCardLayout = ({ paymentInstruments, onDelete, onPrimary, onAddNewPayment }, { testId }) => {
  const defaultPayment = paymentInstruments.find(payment => payment.primaryPaymentMethod);
  const otherPayments = paymentInstruments.filter(payment => !payment.primaryPaymentMethod);

  return (
    <div>
      {defaultPayment && (
        <div className={styles.defaultCard} data-test-id={testId('defaultPaymentType')}>
          <h2>Default Payment</h2>
          <ul>
            <PaymentCard
              card={defaultPayment}
              onDelete={onDelete}
              onPrimary={onPrimary}/>
          </ul>
        </div>
      )}
      <div className={styles.otherCards}>
        {defaultPayment ? <h2>Other Payments</h2> : <h2>Payment Methods</h2>}
        {!paymentInstruments.length ? <div className={styles.empty} data-test-id={testId('noPaymentsOnAccount')}>There are no payment methods associated with this account.</div> : null}
        <MartyLink
          to="/payments/new"
          className={styles.addNewItem}
          onClick={onAddNewPayment}
          data-test-id={testId('addNewPayment')}>Add New Payment</MartyLink>
        <ul className={styles.cardGrid}>
          {otherPayments.map(payment => (
            <PaymentCard
              key={payment.paymentInstrumentId}
              card={payment}
              onDelete={onDelete}
              onPrimary={onPrimary}/>
          ))}
        </ul>
      </div>
    </div>
  );
};

PaymentCardLayout.contextTypes = {
  testId: PropTypes.func
};

PaymentCardLayout.propTypes = {
  paymentInstruments: PropTypes.array.isRequired,
  onDelete: PropTypes.func.isRequired,
  onPrimary: PropTypes.func.isRequired
};

export default PaymentCardLayout;
